let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("fZt2F"), load("6wr18"), load("ffEVr"), load("kZjBp")]).then(() => parcelRequire('1xLOH'));